var map = {
	"./anm-card.png": 1216,
	"./arrow.png": 1217,
	"./arrow.webp": 1218,
	"./asset-1.svg": 1219,
	"./bg-exclusive.webp": 1220,
	"./boost.svg": 1221,
	"./brand-logo-cny.png": 1222,
	"./brand-logo-raya.webp": 1223,
	"./brand-logo.png": 113,
	"./brand-logo.webp": 1224,
	"./btn-black-m.webp": 1225,
	"./btn-blue-m-v2.png": 1226,
	"./btn-blue-m.png": 1227,
	"./btn-blue-m.webp": 1228,
	"./btn-white-m-v2.png": 1229,
	"./btn-white-m.png": 1230,
	"./check-btn.webp": 1231,
	"./default-bg.webp": 1232,
	"./deposit.webp": 1233,
	"./drop-more-btn.webp": 1234,
	"./duitnow.svg": 1235,
	"./eeziepay.svg": 1236,
	"./fcl.svg": 1237,
	"./fcl.webp": 1238,
	"./fpx-logo.svg": 1239,
	"./game-blue.png": 1240,
	"./game-img.png": 1241,
	"./game-white.png": 1242,
	"./global-language.svg": 1243,
	"./grabpay.svg": 1244,
	"./ifm-logo.svg": 1245,
	"./ifm-logo.webp": 1246,
	"./modal-bg.jpg": 1247,
	"./number-bg.webp": 1248,
	"./pagcor.svg": 1249,
	"./pagcor.webp": 1250,
	"./pool-bg.webp": 1251,
	"./promo-given.webp": 1252,
	"./side-bar-bg.png": 1253,
	"./spotlight-base.svg": 1254,
	"./spotlight.svg": 1255,
	"./tether.svg": 1256,
	"./title-asset.svg": 1257,
	"./tng.svg": 1258,
	"./winner.webp": 1259,
	"./withdrawal.webp": 1260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;